exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Value-CellClass[data-v-49f99723]{font-size:16px}.Title-CellClass[data-v-49f99723]{text-align:left;font-size:.5rem;line-height:.875rem}.btn-test[data-v-49f99723]{margin-top:1rem}", ""]);

// exports
